@let fieldData = field();
@let formControl = control();

@if (formControl) {
  <div
    class="input-photos-field"
    [class.border]="fieldData.isHighlighted"
    [class.border-black]="fieldData.isHighlighted"
    [class.p-3]="fieldData.isHighlighted"
    [class.rounded]="fieldData.isHighlighted"
  >
    <label class="block text-sm font-medium x-text-dark-main mb-2">
      {{ fieldData.title }}
      @if (fieldData.helpText) {
        <span
          class="ml-1 text-gray-400 cursor-help"
          [tuiHint]="fieldData.helpText"
          tuiHintDirection="top"
        >
          ⓘ
        </span>
      }
    </label>
    @if (formControl.invalid && (formControl.dirty || formControl.touched)) {
      <div class="text-red-500 x-text-wf-error x-font-body-4 mb-1 text-center">
        @if (formControl.hasError('required')) {
          <span>Обязательное поле</span>
        }
        @if (formControl.hasError('minArrayLength')) {
          <span
            >Минимальное количество фото:
            {{ formControl.getError('minArrayLength').min }}</span
          >
        }
        @if (formControl.hasError('maxArrayLength')) {
          <span
            >Максимальное количество фото:
            {{ formControl.getError('maxArrayLength').max }}</span
          >
        }
        @if (formControl.hasError('invalidMimetypes')) {
          <span>Недопустимый формат изображения</span>
        }
        @if (formControl.hasError('customError')) {
          <span>Ошибка валидации</span>
        }
      </div>
    }

    @if ($photosCount() === 0) {
      @if (fieldData.allowFromCamera) {
        <!-- Скрытый input для камеры (с capture) -->
        <input
          class="hidden"
          #cameraInput
          type="file"
          [accept]="$accept()"
          capture="environment"
          (change)="onFileSelected($event)"
        />

        <button
          class="w-full mb-4"
          type="button"
          tuiButton
          appearance="primary"
          size="m"
          [disabled]="!canExecuteWorkflow()"
          (click)="cameraInput.click()"
        >
          {{ 'workflows.take_photo' | translate }}
        </button>
      }

      @if (fieldData.allowFromGallery) {
        <!-- Скрытый input для галереи (без capture) -->
        <input
          class="hidden"
          #fileInput
          type="file"
          multiple
          [accept]="$accept()"
          (change)="onFileSelected($event)"
        />

        <button
          class="w-full"
          type="button"
          tuiButton
          appearance="outline-grayscale"
          tuiAppearanceMode="checked"
          size="m"
          [disabled]="!canExecuteWorkflow()"
          (click)="selectFiles()"
        >
          {{ 'workflows.upload_from_gallery' | translate }}
        </button>
      }
    } @else {
      <button
        class="w-full relative"
        type="button"
        tuiButton
        appearance="outline-grayscale"
        tuiAppearanceMode="checked"
        size="m"
        (click)="photoSelected.emit([])"
      >
        <span>{{
          'workflows.added_photos' | translate: { count: $photosCount() }
        }}</span>
        @if (pendingCount() > 0) {
          <span class="absolute right-4 top-1/2 -translate-y-1/2">
            <tui-loader class="opacity-50" [size]="'s'"></tui-loader>
          </span>
        }
      </button>
    }
  </div>
}
